import Box from '@/common/components/Box'
import { ErrorMessageWrapper } from '@/common/components/ErrorMessageWrapper'
import ResumeBox from '@/common/components/ResumeBox'
import { ShowHeader } from '@/common/components/ShowHeader'
import { formatDate, formatDateInLocalTimezone } from '@/common/utils/formatters'
import { useFederalLottery } from '@/features/federalLotteries/hooks/useFederalLottery'
import { useParams } from 'react-router-dom'

const Show = () => {
  const { id } = useParams()

  const {
    data: contest,
    isPending: contestIsPending,
    error: contestError = {} as any,
    refetch: refetchContest,
  } = useFederalLottery(id || '')

  return (
    <div className="inner-screen">
      <ShowHeader
        goBack
        goBackProps={{ fallback: '/federal-lotteries' }}
        title="Concursos da Loteria Federal"
        subtitle={contest?.number ? `Concurso #${contest.number}` : undefined}
        isLoading={contestIsPending}
      />

      <ErrorMessageWrapper className="flex-1" statusCode={contestError?.status} refetchFunction={refetchContest}>
        <Box className="flex flex-col overflow-auto gap-6 shadow-[4px_4px_8px_4px_rgba(0,_0,_0,_0.2)]">
          <div className="grid grid-cols-2 gap-6">
            <ResumeBox
              label="Número do concurso"
              value={contest?.number?.toString() ?? '--'}
              isLoading={contestIsPending}
              testId="federal_lottery_number"
            />

            <ResumeBox
              label="Ticket sorteado"
              value={contest?.first_place_ticket ?? '--'}
              isLoading={contestIsPending}
              testId="federal_lottery_first_place_ticket"
            />

            <ResumeBox
              label="Data de criação"
              value={contest?.created_at ? formatDate(new Date(contest.created_at)) : '--'}
              isLoading={contestIsPending}
              testId="federal_lottery_created_at"
            />

            <ResumeBox
              label="Data do sorteio"
              value={contest?.date ? formatDateInLocalTimezone(contest.date) : '--'}
              isLoading={contestIsPending}
              testId="federal_lottery_date"
            />
          </div>
        </Box>
      </ErrorMessageWrapper>
    </div>
  )
}

export default Show
